import { type ISelectionStrategy } from './abstract.selection.strategy';

export class DefaultSingleCheckingSelectionStrategy implements ISelectionStrategy {
    constructor(private selection) {}

    public update(items) {
        if (!this.selection) {
            return;
        }

        let selected = 0;
        this.selection.getSelectedItems().then(res => {
            selected = res[0];
            if (
                this.selection &&
                this.selection.single &&
                (this.selection.size === 0 || (selected && !items.find(item => item.id === selected))) &&
                items.length
            ) {
                this.selection.toggle(items[0]);
            } else if (this.selection && this.selection.single && selected && !items.find(item => item.id === selected) && !items.length) {
                this.selection.deselectAll();
            }
        });
    }
}
